module.exports = __webpack_public_path__ + "img/8_dice[2].cb367910.png";